import {Container, Row, Col} from 'react-bootstrap';
import {Button, Calculator, TextField} from '../../../common';
import {useEffect, useRef, useState} from 'react';
import {useLanguageContext, useThemeContext} from '../../../../context';
import PosAppModal from '../PosAppModal';
import {DEVICE_HEIGHT} from '../../../../constants';

const ItemDiscountsModal = ({toggle, setToggle, handleSave, selectedItem, showDiscountType, title, from}) => {
    const {I18n} = useLanguageContext();
    const {theme} = useThemeContext();

    const textBoxRef = useRef(null);
    const [type, setType] = useState();
    const [value, setValue] = useState();
    const [errors, setErrors] = useState({});

    useEffect(() => {
        let paymentType;
        let paymentAmount;

        if (!selectedItem) {
            paymentType = 'amount';
            paymentAmount = 0;
        } else if (from === 'customer') {
            paymentType = 'amount';
            paymentAmount = selectedItem?.total_credit;
        } else if (from === 'item') {
            paymentType = selectedItem?.product_level_discount?.discountType;
            paymentAmount = selectedItem?.product_level_discount?.discountAmount;
        } else {
            paymentType = selectedItem?.discount_type;
            paymentAmount = selectedItem?.discount;
        }

        setType(paymentType);
        setValue(paymentAmount);
    }, [selectedItem]);

    useEffect(() => {
        textBoxRef?.current?.focus();
    }, [type]);

    const handleClose = event => {
        setToggle(false);
    };
    useEffect(() => {
        let valueToCompare;
        if (from === 'customer') {
            valueToCompare = selectedItem?.total_credit;
        } else if (from === 'item') {
            valueToCompare = selectedItem?.product_level_discount?.discountAmount;
        } else {
            valueToCompare = selectedItem?.selectedItem?.selling_price;
        }

        if (value > 100 && type == 'percentage') {
            setErrors({
                textBox: 'Percentage must be less than 100',
            });
        } else if (selectedItem && value > valueToCompare && type == 'amount') {
            setErrors({
                textBox: 'Discount must be less than Amount',
            });
        } else {
            setErrors({});
        }
    }, [value]);

    const onChange = (label, val) => {
        if (label == I18n.rupees) setValue(val);
        else if (label == I18n.percentage) setValue(val);
    };

    const handleType = val => {
        if (val !== type) {
            setType(val);
            setValue('');
        }
    };

    const handleDone = () => {
        handleSave(type, value);
    };
    const handleCancel = () => {
        handleClose();
    };

    const handleEnterPress = event => {
        if (event.key === 'Enter' && value) {
            handleDone();
            handleClose();
        }
    };
    return (
        <PosAppModal
            className="selectCustomerModal"
            toggle={toggle}
            backCta={{
                name: 'backArrowIcon',
                fill: theme.barclaysBlue,
                width: '18',
                height: '18',
                viewBox: '0 0 18 18',
            }}
            handleClose={handleClose}
            bottomSaveCta={{
                title: I18n.save,
                action: () => handleDone(),
                disabled: value < 0 || Object.keys(errors)?.length,
            }}
            bottomCancelCta={{
                title: I18n.cancel,
                action: () => handleCancel(),
            }}
            title={title}>
            <Container>
                <Row className="justify-content-md-center">
                    <Col md={8}>
                        <div
                            className="itemLevelPopupMain"
                            style={{
                                height: DEVICE_HEIGHT - 200,
                            }}
                            onKeyDown={handleEnterPress}>
                            <div className="discoountButtonInputBox">
                                {showDiscountType && (
                                    <div className="selectDiscountButton">
                                        <Button
                                            className={`rupeesDiscount fontWeight400 fontSize22 cursorPointer`}
                                            backgroundColor={type == 'amount' ? theme.barclaysBlue : theme.seperatorTwo}
                                            txtColor={theme.white}
                                            title={I18n.rupees}
                                            handleClick={() => handleType('amount')}
                                        />
                                        <Button
                                            className={`percentDiscount  fontWeight400 fontSize22 cursorPointer`}
                                            backgroundColor={type == 'percentage' ? theme.barclaysBlue : theme.seperatorTwo}
                                            txtColor={theme.white}
                                            title={I18n.percentage}
                                            handleClick={() => handleType('percentage')}
                                        />
                                    </div>
                                )}

                                <div className={errors?.textBox ? 'discountTextFeildBox discountErrorTextFeildBox' : 'discountTextFeildBox'}>
                                    <TextField
                                        onChange={onChange}
                                        label={type == 'amount' ? I18n.rupees : I18n.percentage}
                                        value={value}
                                        maxLength={6}
                                        error={errors?.textBox}
                                        autoFocus={true}
                                        type="numeric"
                                        inputRef={textBoxRef}
                                    />
                                </div>
                            </div>
                            <div className="billScreenCalculator">
                                <Calculator className={`width55`} columnFour={false} setState={setValue} state={value} />
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </PosAppModal>
    );
};

export default ItemDiscountsModal;
